import React from "react"

export const Instagram = props => (
  <svg height={23} width={23} {...props}>
    <defs>
      <path id="Instagram_svg__a" d="M0 0h23v23H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="Instagram_svg__b" fill="#fff">
        <use xlinkHref="#Instagram_svg__a" />
      </mask>
      <path
        d="M11.5 0C8.376 0 7.985.014 6.758.069c-1.223.056-2.06.249-2.792.534A5.63 5.63 0 0 0 1.93 1.929 5.65 5.65 0 0 0 .603 3.966C.319 4.697.125 5.535.069 6.758.012 7.985 0 8.376 0 11.5c0 3.122.012 3.513.069 4.742.056 1.223.25 2.06.534 2.79A5.65 5.65 0 0 0 1.93 21.07a5.652 5.652 0 0 0 2.036 1.327c.733.284 1.569.478 2.792.533 1.227.056 1.618.07 4.742.07 3.124 0 3.515-.014 4.742-.07 1.223-.055 2.06-.25 2.79-.533a5.645 5.645 0 0 0 2.038-1.327 5.647 5.647 0 0 0 1.326-2.038c.285-.73.479-1.567.535-2.79.055-1.229.069-1.62.069-4.742 0-3.124-.014-3.515-.069-4.742-.056-1.223-.25-2.06-.535-2.792A5.647 5.647 0 0 0 21.07 1.93 5.623 5.623 0 0 0 19.032.603c-.73-.285-1.567-.478-2.79-.534C15.015.014 14.624 0 11.5 0m0 2c3.094 0 3.46.012 4.682.068 1.13.051 1.744.24 2.152.398.54.21.926.462 1.333.867.405.405.656.791.865 1.334.16.407.349 1.02.4 2.151.056 1.221.068 1.587.068 4.683 0 3.094-.012 3.461-.068 4.682-.051 1.13-.24 1.743-.4 2.152-.209.54-.46.927-.865 1.332a3.596 3.596 0 0 1-1.333.867c-.408.16-1.021.347-2.152.4-1.22.055-1.588.066-4.682.066-3.094 0-3.461-.011-4.682-.067-1.13-.052-1.744-.24-2.153-.4a3.602 3.602 0 0 1-1.332-.866 3.597 3.597 0 0 1-.867-1.332c-.158-.41-.347-1.023-.398-2.152C2.011 14.963 2 14.595 2 11.501c0-3.096.011-3.462.068-4.683.051-1.13.24-1.744.398-2.151.211-.543.462-.929.867-1.334a3.602 3.602 0 0 1 1.332-.867c.41-.158 1.022-.347 2.153-.398C8.038 2.012 8.406 2 11.5 2"
        fill="#FFF"
        mask="url(#Instagram_svg__b)"
      />
      <path
        d="M11.5 15a3.5 3.5 0 1 1 0-7 3.5 3.5 0 1 1 0 7m0-9a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M19 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        fill="#FFF"
        mask="url(#Instagram_svg__b)"
      />
    </g>
  </svg>
)
